enum ActionType {
  Play,
  Discard,
  ColorClue,
  RankClue,
  GameOver,
}
export default ActionType;
